import { INTAKE_FORMS, INTAKE_SNAPSHOT } from "../pages/intakeDefinitions";

// CLIENT SNAPSHOT — the most clinically useful intake answers at the top of a
// completed client record. Pure field mapping: the parent's ACTUAL stored
// answers, verbatim, in a scannable layout. No AI, no summaries, no
// interpretation. One component for all three stages — the per-stage question
// mapping lives in INTAKE_SNAPSHOT. Rows/notes with no answer are hidden
// (every question is optional) rather than shown blank.
const clean = (v) => {
  if (Array.isArray(v)) {
    const parts = v.filter((c) => typeof c === "string" && c.trim());
    return parts.length ? parts.join("; ") : null;
  }
  return typeof v === "string" && v.trim() ? v.trim() : null;
};

export const ClientSnapshot = ({ stage, answers, testid }) => {
  const def = INTAKE_FORMS[stage];
  const cfg = INTAKE_SNAPSHOT[stage];
  if (!def || !cfg || !answers) return null;

  const rows = cfg.rows
    .map((r) => ({
      label: r.label,
      value: r.keys.map((k) => clean(answers[k])).filter(Boolean).join(r.join || " · "),
    }))
    .filter((r) => r.value);

  const notes = cfg.notes
    .map((k) => ({
      key: k,
      wording: (def.questions.find((q) => q.key === k) || {}).wording,
      answer: clean(answers[k]),
    }))
    .filter((n) => n.wording && n.answer);

  if (!rows.length && !notes.length) return null;

  return (
    <div data-testid={testid}>
      {rows.length > 0 && (
        <div data-testid={`${testid}-rows`}>
          {rows.map((r) => (
            <div key={r.label} className="flex gap-3 py-1 text-sm">
              <span className="w-32 shrink-0 text-[10px] tracking-[0.15em] uppercase font-semibold text-smoke pt-0.5">
                {r.label}
              </span>
              <span className="text-ink leading-relaxed">{r.value}</span>
            </div>
          ))}
        </div>
      )}
      {notes.length > 0 && (
        <div data-testid={`${testid}-notes`} className={rows.length ? "mt-4 border-t border-ink/10 pt-3" : ""}>
          <p className="text-[10px] tracking-[0.22em] uppercase font-semibold text-euca">
            Key Parent Notes
          </p>
          {notes.map((n) => (
            <div key={n.key} data-testid={`${testid}-note-${n.key}`} className="mt-3">
              <p className="text-[10px] tracking-[0.12em] uppercase font-semibold text-smoke">
                {n.wording.trim()}
              </p>
              <p className="mt-1 text-sm leading-relaxed text-ink whitespace-pre-line">{n.answer}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
